/* DARKGROUND DESIGN SYSTEM · lightweight background videos (see snippets/dg-video.liquid)
   Same videos as before; only the moment and the file size of the download change.
   - Videos start with no source: only the still shows, so the page text and images load first.
   - Nothing starts before the page has loaded (or 2.5 s have passed, whichever comes first), except the
     first-screen video (data-dg-eager), which starts at once.
   - Then a video gets its source when it is within 250px of the screen: the 1080p file on screens wider than
     1280px (same as before) and the 720p file on phones and small laptops. Off screen it pauses.
   - Videos marked data-dg-managed live in the home slideshow: each one loads and plays only while its slide
     is the active one (the slideshow script handles pausing).
   - With reduced motion, only the still is shown.
*/
(function () {
  'use strict';
  if (window.dgVideo) return;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var idle = document.readyState === 'complete';
  var waiting = [];
  function flush() {
    if (idle) return;
    idle = true;
    var q = waiting;
    waiting = [];
    q.forEach(function (f) { try { f(); } catch (e) {} });
  }
  if (!idle) {
    window.addEventListener('load', flush, { once: true });
    setTimeout(flush, 2500);
  }
  function whenIdle(fn) { if (idle) fn(); else waiting.push(fn); }

  function pick(v) {
    var large = !!(window.matchMedia && window.matchMedia('(min-width: 1281px)').matches);
    return (large ? v.dataset.fhd : v.dataset.hd) || v.dataset.fhd || v.dataset.hd || '';
  }
  function showPoster(v) {
    if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster);
  }
  function ensure(v) {
    if (!v) return;
    showPoster(v);
    if (reduced || v.getAttribute('src')) return;
    var u = pick(v);
    if (!u) return;
    if (v.dataset.fhd && u !== v.dataset.fhd) {
      /* lighter file not available: fall back to the 1080p one */
      v.addEventListener('error', function () {
        if (v.getAttribute('src') === v.dataset.fhd) return;
        v.setAttribute('src', v.dataset.fhd);
        if (v.__dgWantPlay) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      }, { once: true });
    }
    v.setAttribute('src', u);
  }
  function play(v) {
    v.__dgWantPlay = true;
    ensure(v);
    if (reduced || !v.getAttribute('src')) return;
    v.muted = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      v.__dgIn = e.isIntersecting;
      if (e.isIntersecting) {
        showPoster(v);
        if (v.hasAttribute('data-dg-eager')) play(v);
        else whenIdle(function () { if (v.__dgIn) play(v); });
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { rootMargin: '250px 0px' }) : null;

  function bindManaged(v) {
    var slide = v.closest('[data-slide]');
    if (!slide) { whenIdle(function () { play(v); }); return; }
    function check() {
      if (!slide.classList.contains('is-active')) return;
      showPoster(v);
      if (v.hasAttribute('data-dg-eager')) play(v);
      else whenIdle(function () { if (slide.classList.contains('is-active')) play(v); });
    }
    if ('MutationObserver' in window) new MutationObserver(check).observe(slide, { attributes: true, attributeFilter: ['class'] });
    check();
  }

  function scan(root) {
    (root || document).querySelectorAll('video[data-dg-video]').forEach(function (v) {
      if (v.dataset.dgVideoBound) return;
      v.dataset.dgVideoBound = '1';
      if (v.hasAttribute('data-dg-managed')) { bindManaged(v); return; }
      if (io) io.observe(v);
      else whenIdle(function () { play(v); });
    });
  }

  window.dgVideo = { ensure: ensure, play: play, whenIdle: whenIdle };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
